import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from '../lib/axios';
import Modal from './Modal';
import ReactRailsUJS from "../lib/react-rails";

export default class extends Component {
  static propTypes = {
    previewPath: PropTypes.string.isRequired,
    previewData: PropTypes.any,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    target: PropTypes.string,
  }

  static defaultProps = {
    text: 'Preview',
    previewData: undefined,
    disabled: false,
  }

  constructor(props) {
    super(props);

    this.triggerRef = React.createRef();
    this.state = {
      open: false,
      previewContent: null,
    };
  }

  handleClick = (e) => {
    if (this.triggerRef.current.contains(e.target)) {
      const { previewPath, previewData } = this.props;

      axios
        .post(previewPath, { fields: JSON.stringify(previewData) })
        .then((response) => {
          this.setState({ open: true, previewContent: response.data }, () => {
            ReactRailsUJS.mountComponents('#modal-container');
            window.Union.setupWizard('#modal-container');
            window.Union.initializeTippy();

            const form = $('#preview .Form');

            // Disable Form
            form.on('submit', (e) => {
              e.preventDefault();
              e.stopPropagation();
              return false;
            });
            // Hide submit button
            form.find('button[type=submit], input[type=submit]').hide().attr('disabled', 'disabled');
            // Hide onboarding navigation
            form.find('.Onboarding-navigation').hide();
            // Hide the validation hint text below the submit button
            // We're a bit creative here since this element's visibility is triggered by
            // the validation JS.
            form.find('*[data-validatable-hint]').css('visibility', 'hidden');
          });
        });
      e.preventDefault();
    }
  }

  handleModalClose = () => {
    this.setState({ open: false, previewContent: null });
  }

  render() {
    return (
      <button
        ref={this.triggerRef}
        className={`Button Button--xsmall ${this.props.disabled ? 'is-disabled' : ''}`}
        onClick={this.handleClick}
        id={`preview-${this.props.target}`}
      >
        {this.props.text}
        {this.state.open && this.state.previewContent &&
          <Modal onClose={this.handleModalClose.bind(this)}>
            <div id="modal-container" dangerouslySetInnerHTML={{__html: this.state.previewContent}} />
          </Modal>
        }
      </button>
    );
  }
}
